export const a = {
  name: 'kub-rand-a',
  anzahlOesenID: 'kub-rand-saum-a',
  title: 'a',
  type: {
    name: 'Schnittkante',
    code: 'R01'
  },
  oesenAnzahl: 0,
  id: 1
}

export const b = {
  name: 'kub-rand-b',
  anzahlOesenID: 'kub-rand-saum-b',
  title: 'b',
  type: {
    name: 'Schnittkante',
    code: 'R01'
  },
  oesenAnzahl: 0,
  id: 2
}

export const c = {
  name: 'kub-rand-c',
  anzahlOesenID: 'kub-rand-saum-c',
  title: 'c',
  type: {
    name: 'Schnittkante',
    code: 'R01'
  },
  oesenAnzahl: 0,
  id: 3
}

export const d = {
  name: 'kub-rand-d',
  anzahlOesenID: 'kub-rand-saum-d',
  title: 'd',
  type: {
    name: 'Schnittkante',
    code: 'R01'
  },
  oesenAnzahl: 0,
  id: 4
}

export const e = {
  name: 'kub-rand-e',
  anzahlOesenID: 'kub-rand-saum-e',
  title: 'e',
  type: {
    name: 'Schnittkante',
    code: 'R01'
  },
  oesenAnzahl: 0,
  id: 5
}

export const f = {
  name: 'kub-rand-f',
  anzahlOesenID: 'kub-rand-saum-f',
  title: 'f',
  type: {
    name: 'Schnittkante',
    code: 'R01'
  },
  oesenAnzahl: 0,
  id: 6
}

export const g = {
  name: 'kub-rand-g',
  anzahlOesenID: 'kub-rand-saum-g',
  title: 'g',
  type: {
    name: 'Schnittkante',
    code: 'R01'
  },
  oesenAnzahl: 0,
  id: 7
}

export const h = {
  name: 'kub-rand-h',
  anzahlOesenID: 'kub-rand-saum-h',
  title: 'h',
  type: {
    name: 'Schnittkante',
    code: 'R01'
  },
  oesenAnzahl: 0,
  id: 8
}
